<template>
    <b-nav-item-dropdown
        v-if="isNavHorizontal"
        data-top-right-id="recents"
        id="nav-item-audit"
        @show="logClicked"
        no-caret
        right
    >
        <template slot="button-content">
            <i class="fas fa-bolt page_white_lightning"></i>
            <span class="d-lg-none">Recent</span>
        </template>
        <b-dropdown-item
            @click="goToPage(log)"
            v-for="log in filteredLogs"
            :key="log.id"
        >
            <div class="item">
                <module-icon :name="log.sub_module" class="icon" />
                <div class="content">
                    <div>{{ log.text }}</div>
                    <div class="module">
                        {{ capitalizeFirstLetter(log.sub_module) }}
                    </div>
                </div>
            </div>
        </b-dropdown-item>
    </b-nav-item-dropdown>

    <li v-else class="left-nav-option">
        <button @click="logClicked" class="option-toggle">
            <span style="width: 14px;">
                <i class="fas fa-bolt page_white_lightning"></i>
            </span>
            <span>Recent</span>
        </button>
        <ul class="option-menu" v-if="showOptionMenu">
            <li v-for="log in filteredLogs" :key="log.id">
                <button class="option-menu-item" @click="handleRouting(log)">
                    <module-icon :name="log.sub_module" class="icon" />
                    <span
                        class="d-flex flex-column align-items-start justify-content-center w-100"
                    >
                        <span class="log-text">
                            {{ log.text }}
                        </span>
                        <span class="module">
                            {{ capitalizeFirstLetter(log.sub_module) }}
                        </span>
                    </span>
                </button>
            </li>
        </ul>
    </li>
</template>
<script>
import ModuleIcon from "@/module/layout/module-icon";
import recentLog from "@/mixins/recent-log";

export default {
    components: {
        ModuleIcon
    },
    props: {
        isNavHorizontal: {
            type: Boolean,
            default: true
        },
        showOptionMenu: {
            type: Boolean,
            default: false
        }
    },
    mixins: [recentLog],
    data() {
        return {
            businesses: [],
            logs: [],
            currentActor: null,
            setting: {}
        };
    },
    methods: {
        async logClicked() {
            this.logs = await this.getLogs();
        },
        handleRouting(log) {
            if (!this.isNavHorizontal) {
                this._toggleEnhancedLayoutMobileSideMenu();
            }

            this.goToPage(log);
        }
    }
};
</script>

<style lang="scss" scoped>
.item {
    display: flex;
    gap: 8px;
    align-items: flex-start;

    .icon {
        width: 20px;
        height: auto;
    }

    .module {
        font-size: 0.8em;
        font-weight: normal;
        color: #4a4a4a;
    }
}

.left-nav-option {
    width: 100%;

    button {
        border: 0;
        outline: 0;
        background: transparent;
        width: 100%;
        font-weight: 500;

        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }

        &:focus-visible {
            box-shadow: 0 0 0 0 #fff, 0 0 0 2px rgba(59, 130, 246, 0.5),
                0 0 #0000;
        }
    }

    .option-toggle {
        display: flex;
        gap: 10px;
        height: 36px;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        border-radius: 4px;
        color: #fff;

        span {
            font-size: 0.875rem;
        }
    }

    .option-menu {
        display: flex;
        flex-direction: column;
        margin: 4px 0 4px 0;
        padding: 4px 0;
        list-style: none;
        border-radius: 4px;
        background: #fff;
    }

    .option-menu-item {
        display: flex;
        gap: 8px;
        align-items: start;
        padding: 8px 12px 8px 38px;

        &:hover {
            background: #c9ccde;
        }

        .icon {
            width: 18px;
            height: 18px;
        }

        .module {
            font-size: 0.75rem;
            color: #4a4a4a;
        }

        .log-text {
            font-size: 0.825rem;
            text-align: left;
        }
    }
}
</style>
